import { render, staticRenderFns } from "./AloneTalkEdit.vue?vue&type=template&id=7bf54e06"
import script from "./AloneTalkEdit.vue?vue&type=script&lang=js"
export * from "./AloneTalkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports